import { procurementAPI } from "../../axios";

export const actions = {
    GetPendingResolution(context, data){
        return procurementAPI.get(`PrResolutionMember/My/Pending`);
    },
    GetApprovedResolution(context, data){
        return procurementAPI.get(`PrResolutionMember/My/Approved`);
    },
    ApproveResolution(context, data){
        return procurementAPI.post(`PrResolutionMember/Approve/${data}`);
    },
    ChangeBACMember(context, data){
        return procurementAPI.post(`PrResolutionMember/Change/${data.id}`, data);
    },
    RemoveBACMember(context, data){
        return procurementAPI.delete(`PrResolutionMember/${data}`);
    },
    GetResolutionMembers(context, data){
        return procurementAPI.get(`PrResolutionMember/PrResolution/${data}`);
    },
}